import { composeReducers } from 'common/util/composeReducers';
import { actionButtonPropertyReducer } from 'common/reducers/actionButton';
import bindersOverviewReducer from './binders';
import { setDashboardDataReducer, loadedDashboardDataReducer, loadingDashboardDataReducer, setDashboardBinderStudiesReducer,setDashboardBinderStudiesAdminBindersReducer,setDashboardBinderStudiesReducerTasks,setDashboardStudyBinderQueryCount,setDashboardAdminBinderQueryCount, loadedDashboardBinderStudiesReducer,loadingDashboardBinderStudiesReducer, loadedDashboardBinderStudiesAdminBindersReducer, loadingDashboardBinderStudiesAdminBindersReducer, setPinnedBindersReducer, setUnfiledDocumentsCountToBinderReducer, loadingUnfiledDocsCount, setPendingTasksToBindersReducer, loadingPendingTasks, clearDashboardData, setBinderCustomColumns } from './dashboard';
import { studiesOverviewReducer, unloadStudiesOverviewReducer, loadStudyStagesReducer } from './studies';

import {
    LOAD_BINDER_TEMPLATES,
    CREATE_BINDER_SUCCESS,
    CREATE_BINDER_IN_PROGRESS
} from 'overview/actions';


function loadBinderTemplates(state, action) {
    if (!action || action.type !== LOAD_BINDER_TEMPLATES) {
        return state;
    }

    const binderTemplates = action.payload;
    if (!binderTemplates) {
        return state;
    }

    return {
        ...state,
        me: {
            ...state.me,
            binderTemplates
        }
    };
}

function createBinderSuccess(state, action) {
    if (!action || action.type !== CREATE_BINDER_SUCCESS) {
        return state;
    }

    const { binderId } = action.payload;

    if (!binderId) {
        return state;
    }

    return {
        ...state,
        binder: {
            id: binderId,
            createBinderSuccess: true,
            createBinderInProgress: false
        }
    };
}

function createBinderInProgress(state, action) {
    if (!action || action.type !== CREATE_BINDER_IN_PROGRESS) {
        return state;
    }

    return {
        ...state,
        binder: {
            createBinderInProgress: true
        }
    };
}

export default composeReducers(
    loadBinderTemplates,
    actionButtonPropertyReducer,
    bindersOverviewReducer,
    studiesOverviewReducer,
    loadedDashboardDataReducer,
    loadingDashboardDataReducer,
    loadedDashboardBinderStudiesReducer,
    loadingDashboardBinderStudiesReducer,
    loadedDashboardBinderStudiesAdminBindersReducer,
    loadingDashboardBinderStudiesAdminBindersReducer,
    loadingPendingTasks,
    setDashboardDataReducer,
    setDashboardBinderStudiesReducer,
    setDashboardBinderStudiesAdminBindersReducer,
    setDashboardBinderStudiesReducerTasks,
    setDashboardStudyBinderQueryCount,
    setDashboardAdminBinderQueryCount,
    loadedDashboardDataReducer,
    loadingDashboardDataReducer,
    unloadStudiesOverviewReducer,
    createBinderSuccess,
    createBinderInProgress,
    loadStudyStagesReducer,
    setPinnedBindersReducer,
    setUnfiledDocumentsCountToBinderReducer,
    setBinderCustomColumns,
    loadingUnfiledDocsCount,
    setPendingTasksToBindersReducer,
    clearDashboardData,
);
